import React,{useState} from 'react'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function MerDate(props) {
  const [value, setValue] = useState(props.info.value!==''?props.info.value:null)
  // console.log(props.info.value!==''?props.info.value:null)
  const handleChange = (newValue) => {
    // Manually adjust for IST (UTC+5:30)
    // Check if newValue is a datetime object before setting hours and minutes
    if (newValue instanceof Date && !isNaN(newValue)) {
      newValue.setHours(0, 0, 0, 0);
      newValue.setMinutes(720); // This sets the time to 12:00 PM UTC
      console.log(newValue, "here");
  }

    setValue(newValue);
    props.handleChange(props.info.id,newValue,props.info?._id);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          label={props.info.question_text}
          inputFormat="dd/MM/yyyy"
          value={value}
          onChange={handleChange}
          disabled={!props.abled}
          renderInput={(params) => 
            <TextField 
            InputLabelProps={{
                style: { color: 'black', paddingLeft:'10px' },
            }}
            sx={{marginBottom:2,marginTop:2, maxWidth:'75%' , 
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                  borderColor: 'black',
                },
               },
               '& .MuiFormLabel-asterisk': {
                color: 'red', fontSize: '30px', position: 'absolute', left: '-6px'
               },
            }}
            required={props.info.mandatory}
            autoComplete='off'
            value={value}
            label={props.info.question_text}
            variant="outlined"
            {...params}
            />}
        />
    </LocalizationProvider>
  )
}

export default MerDate
